import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { PARTICIPANT_TYPE_ROUTE_ENUM } from '@/constants/enums'
import { SYSTEM_SETTINGS, ACCOUNT, LOCALIZATION } from '@/constants/store'
import {
  PARTICIPANT_TYPES,
  USER_TYPES,
  DOCUMENT_TYPES
} from '@/constants/business'
// вставить кусок /* webpackChunkName: "userLayout" */ в  import(...'') для понятного именования
const UserLayout = () => import('@/components/reused/layouts/UserLayout')
const AdminLayout = () => import('@/components/reused/layouts/AdminLayout')
// const TestFrame = () => import('@/components/TestFrame')

// ADMIN PAGES
const AdminLogin = () => import('@/components/pages/admin/AdminLogin')

const Logs = () => import('@/components/pages/admin/Logs/Logs.vue')
const TradeRequests = () =>
  import('@/components/pages/admin/Lots/Requests/TradeRequests')
const TradeRequestProcess = () =>
  import('@/components/pages/admin/Lots/Requests/TradeRequestProcess')
const GlobalMailing = () =>
  import('@/components/pages/admin/Mailing/GlobalMailing')
const ParticipantsMailing = () =>
  import('@/components/pages/admin/Mailing/ParticipantsMailing')
const MailingLists = () =>
  import('@/components/pages/admin/Mailing/MailingLists')
const Manage = () => import('@/components/pages/admin/Manage/Manage')
const OrganizationRegistrationRequests = () =>
  import(
    '@/components/pages/admin/OrganizationRegistrationRequest/OrganizationRegistrationRequests'
  )
const OrganizationRequestProcess = () =>
  import(
    '@/components/pages/admin/OrganizationRegistrationRequest/OrganizationRequestProcess'
  )
const OrganizationSummaryAdmin = () =>
  import(
    '@/components/pages/admin/Organizations/Summary/OrganizationSummaryAdmin'
  )
const OrganizationList = () =>
  import('@/components/pages/admin/Organizations/OrganizationList')
const ProductSectionsManagement = () =>
  import('@/components/pages/admin/ProductSections/ProductSectionsManagement')
const ProxiesManagementList = () =>
  import('@/components/pages/admin/Proxies/ProxiesManagementList')
const OrganizationsReport = () =>
  import('@/components/pages/admin/Reports/OrganizationsReport')
const OrganizationsActivityReport = () =>
  import('@/components/pages/admin/Reports/OrganizationsActivityReport')
const BankAccountsReport = () =>
  import('@/components/pages/admin/Reports/BankAccountsReport')
const LotCommissionReport = () =>
  import('@/components/pages/admin/Reports/LotCommissionReport')
const LotsReport = () => import('@/components/pages/admin/Reports/LotsReport')
const ActiveSessions = () =>
  import('@/components/pages/admin/Sessions/ActiveSessions')
const StaticPageEditor = () =>
  import('@/components/pages/admin/StaticPages/StaticPageEditor')
const StaticFilesList = () =>
  import('@/components/pages/admin/StaticPages/StaticFilesList')
const StaticPagesManagement = () =>
  import('@/components/pages/admin/StaticPages/StaticPagesManagement')

const SettingsSummary = () =>
  import('@/components/pages/admin/SystemSettings/SettingsSummary')
const ProductionCalendar = () =>
  import('@/components/pages/admin/SystemSettings/ProductionCalendar')
const ClientThemes = () =>
  import('@/components/pages/admin/SystemSettings/ClientThemes')
const SegmentSettings = () =>
  import('@/components/pages/admin/SystemSettings/SegmentSettings.vue')
const SMTPSettings = () =>
  import('@/components/pages/admin/SystemSettings/SMTPSettings.vue')

const ManualTaskExecution = () =>
  import('@/components/pages/admin/Tasks/ManualTaskExecution')

const UserRegistrationRequests = () =>
  import('@/components/pages/admin/UserRegistration/UserRegistrationRequests')
const UserRequestProcess = () =>
  import('@/components/pages/admin/UserRegistration/UserRequestProcess')

const UserSummaryAdmin = () =>
  import('@/components/pages/admin/Users/Summary/UserSummaryAdmin')
const UsersTabList = () =>
  import('@/components/pages/admin/Users/UsersTabList')

const SignalRTest = () =>
  import('@/components/pages/admin/Validators/SignalRTest')

// SHARED PAGES
const Main = () => import('@/components/pages/shared/Main')

const LotWizard = () =>
  import('@/components/pages/shared/LotRegistration/LotWizard')
const SummarizingLotsList = () =>
  import('@/components/pages/shared/Lots/SummarizingLotsList')
const LotRequestWizard = () =>
  import('@/components/pages/shared/LotRequest/LotRequestWizard')
const Bidding = () => import('@/components/pages/shared/Lots/Bidding/Bidding')
const LotSummary = () =>
  import('@/components/pages/shared/Lots/Summary/LotSummary')
const WinnerSelection = () =>
  import('@/components/pages/shared/Lots/WinnerSelection')

const StartLotRegistration = () =>
  import('@/components/pages/shared/Lots/StartLotRegistration')
const PersonalLots = () =>
  import('@/components/pages/shared/Lots/PersonalLots')
const PublishedLots = () =>
  import('@/components/pages/shared/Lots/PublishedLots')

const SessionWizard = () =>
  import('@/components/pages/shared/SessionRegistration/SessionWizard')

const LotTemplateList = () =>
  import('@/components/pages/shared/LotTemplate/LotTemplateList')
const LotTemplateSummary = () =>
  import('@/components/pages/shared/LotTemplate/LotTemplateSummary')

const OrganizationRegistrationWizard = () =>
  import(
    '@/components/pages/shared/OrganizationRegistrationWizard/OrganizationRegistrationWizard'
  )
const PaymentsGeneration = () =>
  import('@/components/pages/shared/Payment/PaymentsGeneration')
const UserProxies = () =>
  import('@/components/pages/shared/Proxies/UserProxies')

const Login = () => import('@/components/pages/shared/User/Login')
const Registration = () =>
  import('@/components/pages/shared/User/Registration')
const ChangePassword = () =>
  import('@/components/pages/shared/User/ChangePassword')
const EmailConfirmation = () =>
  import('@/components/pages/shared/User/EmailConfirmation')
const ResetPassword = () =>
  import('@/components/pages/shared/User/ResetPassword')
const ResetPasswordConfirmation = () =>
  import('@/components/pages/shared/User/ResetPasswordConfirmation')

const Support = () => import('@/components/pages/shared/Support')
const GeneralDocuments = () =>
  import('@/components/pages/shared/GeneralDocuments')

// USER PAGES

const StartRegistration = () =>
  import('@/components/pages/user/StartRegistration')
const UserRegistrationWizard = () =>
  import(
    '@/components/pages/user/UserRegistrationWizard/UserRegistrationWizard'
  )
const OrganizationSummary = () =>
  import('@/components/pages/user/Organization/OrganizationSummary')

Vue.use(VueRouter)

const allWithoutAdmin = unreg => {
  const participants = Object.keys(PARTICIPANT_TYPE_ROUTE_ENUM)
  if (unreg) {
    participants.push(USER_TYPES.UNREGISTERED)
  }
  return participants
}

// только администратор
const adminRouteMeta = {
  requiresAuth: true,
  participants: [PARTICIPANT_TYPES.ADMINISTRATOR]
}
// любой пользователь, кроме админа, в том числе неаутентифицированный и не прошедший регистрацию УП
const notAdminUserRouteMeta = {
  requiresAuth: false,
  participants: allWithoutAdmin(true)
}
// только аутентифицированный зарегистрированный УП (не админ)
const onlyRegisteredUserRouteMeta = {
  requiresAuth: true,
  participants: allWithoutAdmin(false)
}

// const onlyParticipantRouteMeta = { requiresAuth: true, participants: [PARTICIPANT_TYPES.ORGPART] }

// только организатор
const onlyOrganizerRouteMeta = {
  requiresAuth: true,
  participants: [PARTICIPANT_TYPES.ORGPART]
}

// любой пользователь
const anyUsersRouteMeta = {
  requiresAuth: false,
  participants: []
}
// любой аутентифицированный пользователь, кроме админа, в том числе не прошедший регистрацию УП
const anyAuthUsersRouteMeta = {
  requiresAuth: true,
  participants: allWithoutAdmin(true)
}

const routes = [
  // {
  //   path: '/testFrame',
  //   name: 'TestFrame',
  //   component: TestFrame
  // },
  {
    path: '/:lang(ru|en)?/admin',
    component: AdminLayout,
    meta: adminRouteMeta,
    children: [
      {
        path: '',
        name: 'MainAdmin',
        component: Main,
        meta: adminRouteMeta
      },
      {
        path: 'login',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'signalRTest',
        name: 'SignalRTest',
        component: SignalRTest,
        meta: adminRouteMeta
      },
      {
        path: 'staticFiles',
        name: 'StaticFilesList',
        component: StaticFilesList,
        meta: adminRouteMeta
      },
      {
        path: 'mailingLists',
        name: 'MailingLists',
        component: MailingLists,
        meta: adminRouteMeta
      },
      {
        path: 'paymentsGeneration',
        name: 'adminPaymentsGeneration',
        component: PaymentsGeneration,
        meta: adminRouteMeta
      },
      {
        path: 'smtpSettings',
        name: 'SMTPSettingsAdmin',
        component: SMTPSettings,
        meta: adminRouteMeta
      },
      {
        path: 'segmentSettings',
        name: 'SegmentSettingsAdmin',
        component: SegmentSettings,
        meta: adminRouteMeta
      },
      {
        path: 'tasks',
        name: 'ManualTaskExecution',
        component: ManualTaskExecution,
        meta: adminRouteMeta
      },
      {
        path: 'manage',
        name: 'Manage',
        component: Manage,
        meta: adminRouteMeta
      },
      {
        path: 'tradeRequests/:requestType/:tab?',
        name: 'TradeRequests',
        component: TradeRequests,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'tradeRequest/process/:requestType/:requestId',
        name: 'TradeRequestProcess',
        component: TradeRequestProcess,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'staticPage/:tag',
        name: 'StaticPageEditor',
        component: StaticPageEditor,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'staticPages',
        name: 'StaticPagesManagement',
        component: StaticPagesManagement,
        meta: adminRouteMeta
      },
      {
        path: 'globalMailing',
        name: 'GlobalMailing',
        component: GlobalMailing,
        meta: adminRouteMeta
      },
      {
        path: 'participantsMailing',
        name: 'ParticipantsMailing',
        component: ParticipantsMailing,
        meta: adminRouteMeta
      },
      {
        path: 'logs',
        name: 'logs',
        component: Logs,
        meta: adminRouteMeta
      },
      {
        path: 'productionCalendar',
        name: 'ProductionCalendar',
        component: ProductionCalendar,
        meta: adminRouteMeta
      },
      {
        path: 'lotRegistration',
        name: 'StartLotRegistrationAdmin',
        component: StartLotRegistration,
        meta: adminRouteMeta
      },
      {
        path: 'systemSettings',
        name: 'SettingsSummary',
        component: SettingsSummary,
        meta: adminRouteMeta
      },
      {
        path: 'themes',
        name: 'ClientThemes',
        component: ClientThemes,
        meta: adminRouteMeta
      },
      {
        path: 'productSections',
        name: 'ProductSectionsManagementAdmin',
        component: ProductSectionsManagement,
        meta: adminRouteMeta
      },
      {
        path: 'organizationRegistrationRequests/:tab?',
        name: 'OrganizationRegistrationRequests',
        component: OrganizationRegistrationRequests,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lotWizard/:lotType/:lotId?',
        name: 'LotWizardAdmin',
        component: LotWizard,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/sessionWizard/:sessionType/:sessionId?',
        name: 'SessionWizardAdmin',
        component: SessionWizard,
        props: true,
        meta: adminRouteMeta
      },
      // // частные случаи маршрутов ставим выше
      {
        path: 'lot/:lotType/:lotId/winners',
        name: 'WinnerSelectionAdmin',
        component: WinnerSelection,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/bidding',
        name: 'BiddingAdmin',
        component: Bidding,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/request/:requestType',
        name: 'LotRequestWizardAdmin',
        component: LotRequestWizard,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/:tab?',
        name: 'LotSummaryAdmin',
        component: LotSummary,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'sessions/active',
        name: 'ActiveSessions',
        component: ActiveSessions,
        meta: adminRouteMeta
      },
      {
        path: 'lots/personal/:tab?',
        name: 'PersonalLotsAdmin',
        component: PersonalLots,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lots/published/:tab?',
        name: 'PublishedLotsAdmin',
        component: PublishedLots,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'lots/summarizing',
        name: 'SummarizingLotsListAdmin',
        component: SummarizingLotsList,
        meta: adminRouteMeta
      },
      {
        path: 'templates',
        name: 'LotTemplateListAdmin',
        component: LotTemplateList,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'template/:lotType/:lotTemplateId',
        name: 'LotTemplateSummaryAdmin',
        component: LotTemplateSummary,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'organizationRequestProcess/:organizationId',
        name: 'OrganizationRequestProcess',
        component: OrganizationRequestProcess,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'organization/:organizationId/:tab?',
        name: 'OrganizationSummaryAdmin',
        component: OrganizationSummaryAdmin,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'organizations',
        name: 'OrganizationList',
        component: OrganizationList,
        meta: adminRouteMeta
      },
      {
        path: 'reports/organizations',
        name: 'OrganizationsReport',
        component: OrganizationsReport,
        meta: adminRouteMeta
      },
      {
        path: 'reports/organizationsActivityReport',
        name: 'OrganizationsActivityReport',
        component: OrganizationsActivityReport,
        meta: adminRouteMeta
      },
      {
        path: 'reports/lots/statistics',
        name: 'LotsReport',
        component: LotsReport,
        meta: adminRouteMeta
      },
      {
        path: 'reports/lotCommission',
        name: 'LotCommissionReport',
        component: LotCommissionReport,
        meta: adminRouteMeta
      },
      {
        path: 'reports/bankAccounts',
        name: 'BankAccountsReport',
        component: BankAccountsReport,
        meta: adminRouteMeta
      },
      {
        path: 'userRegistrationRequests/:tab?',
        name: 'UserRegistrationRequests',
        component: UserRegistrationRequests,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'user/proxies',
        name: 'ProxiesAdmin',
        component: UserProxies,
        meta: adminRouteMeta
      },
      {
        path: 'users/:tab?',
        name: 'UsersTabList',
        component: UsersTabList,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'user/:userId/:tab?',
        name: 'UserSummaryAdmin',
        component: UserSummaryAdmin,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'userRequestProcess/:requestId',
        name: 'UserRequestProcess',
        component: UserRequestProcess,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: `proxies/:proxyType(${DOCUMENT_TYPES.USER_PROXY})`,
        name: 'ProxiesManagementList',
        component: ProxiesManagementList,
        props: true,
        meta: adminRouteMeta
      },
      {
        path: 'support',
        name: 'SupportAdmin',
        component: Support,
        meta: adminRouteMeta
      },
      {
        path: 'generalDocuments',
        name: 'GeneralDocumentsAdmin',
        component: GeneralDocuments,
        meta: adminRouteMeta
      },
      {
        path: 'changePassword',
        name: 'ChangePasswordAdmin',
        component: ChangePassword,
        meta: adminRouteMeta
      },
      {
        path: '*',
        redirect: { name: 'MainAdmin' },
        meta: adminRouteMeta
      }
    ]
  },
  {
    path: '/:lang(ru|en)?',
    component: UserLayout,
    meta: notAdminUserRouteMeta,
    children: [
      {
        path: '',
        name: 'Main',
        component: Main,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'registration',
        name: 'Registration',
        component: Registration,
        meta: notAdminUserRouteMeta
      },
      // {
      //   path: 'participantsMailing',
      //   name: 'ParticipantsMailingOrganizer',
      //   component: ParticipantsMailing,
      //   meta: onlyOrganizerRouteMeta
      // },
      {
        path: 'paymentsGeneration',
        name: 'paymentsGeneration',
        component: PaymentsGeneration,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'lotRegistration',
        name: 'StartLotRegistration',
        component: StartLotRegistration,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: 'user/registration/start',
        name: 'StartRegistration',
        component: StartRegistration,
        meta: anyAuthUsersRouteMeta
      },
      {
        path: 'user/registration/organization',
        name: 'OrganizationRegistrationWizard',
        component: OrganizationRegistrationWizard,
        meta: anyAuthUsersRouteMeta
      },
      {
        path: 'user/registration/profile',
        name: 'UserRegistrationWizard',
        component: UserRegistrationWizard,
        meta: anyAuthUsersRouteMeta
      },
      {
        path: 'user/proxies',
        name: 'UserProxies',
        component: UserProxies,
        meta: onlyRegisteredUserRouteMeta
      },
      {
        path: 'user/organization/:tab?',
        name: 'OrganizationSummary',
        component: OrganizationSummary,
        props: true,
        meta: onlyRegisteredUserRouteMeta
      },
      {
        path: 'lotWizard/:lotType/:lotId?',
        name: 'LotWizard',
        component: LotWizard,
        props: true,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/sessionWizard/:sessionType/:sessionId?',
        name: 'SessionWizard',
        component: SessionWizard,
        props: true,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: 'templates',
        name: 'LotTemplateList',
        component: LotTemplateList,
        props: true,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: 'template/:lotType/:lotTemplateId',
        name: 'LotTemplateSummary',
        component: LotTemplateSummary,
        props: true,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/winners',
        name: 'WinnerSelection',
        component: WinnerSelection,
        props: true,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/bidding',
        name: 'Bidding',
        component: Bidding,
        props: true,
        meta: onlyRegisteredUserRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/request/:requestType',
        name: 'LotRequestWizard',
        component: LotRequestWizard,
        props: true,
        meta: onlyRegisteredUserRouteMeta
      },
      {
        path: 'lot/:lotType/:lotId/:tab?',
        name: 'LotSummary',
        component: LotSummary,
        props: true,
        meta: anyUsersRouteMeta
      },
      {
        path: 'support',
        name: 'Support',
        component: Support,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'generalDocuments',
        name: 'GeneralDocuments',
        component: GeneralDocuments,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'changePassword',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: anyAuthUsersRouteMeta
      },
      {
        path: 'emailConfirmation/:userId/:code',
        name: 'EmailConfirmation',
        component: EmailConfirmation,
        props: true,
        meta: anyUsersRouteMeta
      },
      {
        path: 'resetPassword',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'resetPasswordConfirmation/:userName/:code',
        name: 'ResetPasswordConfirmation',
        component: ResetPasswordConfirmation,
        props: true,
        meta: notAdminUserRouteMeta
      },
      {
        path: 'lots/personal/:tab?',
        name: 'PersonalLots',
        component: PersonalLots,
        props: true,
        meta: onlyRegisteredUserRouteMeta
      },
      {
        path: 'lots/published/:tab?',
        name: 'PublishedLots',
        component: PublishedLots,
        props: true,
        meta: anyUsersRouteMeta
      },
      {
        path: 'lots/summarizing',
        name: 'SummarizingLotsList',
        component: SummarizingLotsList,
        meta: onlyOrganizerRouteMeta
      },
      {
        path: '*',
        redirect: { name: 'Main' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

const beforEachHeandler = (to, from, next) => {
  const participant =
    store.state[ACCOUNT.NAMESPACE][ACCOUNT.STATE.PARTICIPANT_TYPE] ||
    USER_TYPES.UNREGISTERED
  const isLoggedIn = store.state[ACCOUNT.NAMESPACE][ACCOUNT.STATE.IS_LOGGED_IN]
  const localizationEnabled =
    store.state[SYSTEM_SETTINGS.NAMESPACE][
      SYSTEM_SETTINGS.STATE.LOCALIZATION_ENABLED
    ]
  // язык по умолчанию или из локальных настроек пользователя

  const localeFromStore = localizationEnabled
    ? store.state[LOCALIZATION.NAMESPACE][LOCALIZATION.STATE.LOCALE]
    : 'ru'
  // язык из параметров url
  const lang = to.params?.lang?.toLowerCase()
  const participants = to.meta.participants || []

  const langsArray = localizationEnabled ? ['en', 'ru'] : ['ru']
  // если получены настройки локализации из url
  if (lang && langsArray.includes(lang)) {
    // если в настройки локализации есть в параметрах, но по какой-то причине не попали в url
    // заменяем текущий маршрут на новый с языком
    if (lang !== localeFromStore) {
      const methodName = `${LOCALIZATION.NAMESPACE}/${LOCALIZATION.ACTIONS.SET_LOCALE_WITHOUT_RELOAD}`
      store.dispatch(methodName, lang)
      window.location.reload()
    }
    if (!to.fullPath.includes(`/${lang}/`)) {
      next({
        path: `/${lang}${to.fullPath}`,
        replace: true
      })
    }

    if (to.meta.requiresAuth && !isLoggedIn) {
      // если требуется аутентификация для текущего маршрута и она не пройдена
      next({
        name: 'Login',
        params: {
          ...to.params,
          lang
        }
      })
    } else if (participants.length > 0 && !participants.includes(participant)) {
      // если требуется проверка ролей и она не пройдена
      next({
        name:
          participant === PARTICIPANT_TYPES.ADMINISTRATOR
            ? 'MainAdmin'
            : 'Main',
        params: {
          ...to.params,
          lang
        }
      })
    } else {
      // если выше не перенаправлено, то идем дальше
      next() // make sure to always call next()!
    }
  } else if (lang && !langsArray.includes(lang)) {
    if (to.fullPath.includes(`/${lang}/`) && localeFromStore !== lang) {
      next({
        path: to.fullPath
          .toLowerCase()
          .replace(`/${lang}/`, `/${localeFromStore}/`),
        replace: true
      })
    }
  } else {
    next({
      path: `/${localeFromStore}${to.fullPath}`,
      replace: true
    })
  }
}

const beforEach = (to, from, next) => {
  if (store.state[SYSTEM_SETTINGS.NAMESPACE][SYSTEM_SETTINGS.STATE.IS_LOADED]) {
    beforEachHeandler(to, from, next)
  } else {
    const methodName = `${SYSTEM_SETTINGS.NAMESPACE}/${SYSTEM_SETTINGS.ACTIONS.GET_LOCALIZATION_STATUS}`

    store.dispatch(methodName).then(() => {
      beforEachHeandler(to, from, next)
    })
  }
}

// настраиваем доступность маршрутов и перенаправления (для администратора и пользователей)
router.beforeEach((to, from, next) => {
  const lang = to.params?.lang?.toLowerCase()
  if (!lang) {
    // если не получены настройки локализации из url,
    // переходим по маршруту с учетом текущих локальных настроек
    // перед получением локализации из стора проверянем,
    // что в соседней вкладке не было изменений
    // перезаписываем изменения из localStorage в localization store текущей вкладки

    const methodName = `${LOCALIZATION.NAMESPACE}/${LOCALIZATION.ACTIONS.REFRESH_LOCALE}`
    store.dispatch(methodName).then(() => {
      beforEach(to, from, next)
    })
  } else {
    beforEach(to, from, next)
  }
})

export default router
